import { CanAccess, Title } from 'react-admin';
import { ReactElement } from 'react';
import { Stack } from '@mui/material';
import { useDefineAppLocation } from '@react-admin/ra-navigation';
import ClicksSummaryWidget from './Widget';

export default function ClicksSummaryPage(): ReactElement {
  useDefineAppLocation('clicks.summary');

  return (
    <>
      <Title title="Clicks Summary" />
      <Stack spacing={3} sx={{ mt: 2, mb: 4 }}>
        <CanAccess resource="clicks_summaries" action="list">
          <ClicksSummaryWidget />
        </CanAccess>
      </Stack>
    </>
  );
}
